import _ from 'lodash'
import {useState, useLayoutEffect} from 'react'
import {Virtuoso} from 'react-virtuoso'

export const EitjeVirtuoso = ({ref, customScrollParent, ...rest}) => {
	const [domElement, setDomElement] = useState(null)

	useLayoutEffect(() => {
		if (_.isString(customScrollParent)) {
			setDomElement(document.querySelector(customScrollParent))
		}
	}, [customScrollParent])

	const needsParent = _.isString(customScrollParent)
	const parent = needsParent ? domElement : customScrollParent
	const ready = !needsParent || !!parent

	// ready check is needed to prevent flicker when the dom element of customScrollParent is not yet set
	if (!ready) return null

	return <Virtuoso ref={ref} customScrollParent={parent} totalCount={rest.data?.length} {...rest} />
}
